class EntityModel {
  constructor(props) {
    const entity = props.length ? props[0] : {};
    Object.assign(this, entity);
  }
}

export default EntityModel;
